import { TEXTOS } from '../../../lib/glossario'
import { CalendarioDoContrato } from './CalendarioDoContrato'
import { CriteriosDoTr } from './CriteriosDoTr'
import { ListaDeApoio } from './ListaDeApoio'
import { PrazosDosRelatorios } from './PrazosDosRelatorios'

/**
 * As listas que alimentam os campos de escolha, e o calendário que mede prazo.
 *
 * **Até esta tela existir, acrescentar um sistema era uma migration e um deploy.** Numa semana de
 * teste com gente de verdade, alguém quer abrir solicitação para um sistema fora da lista — e
 * "espere o próximo release" trava a pessoa por um cadastro de duas palavras. O mesmo vale para um
 * feriado municipal faltando: ele distorce o prazo de todo chamado daquele dia, e o fiscal descobre
 * conferindo, não antes.
 *
 * **Os dois últimos blocos não são "listas".** Fixar o dia limite de entrega de um relatório e
 * registrar uma versão de critério do contrato são ATOS da CONTRATANTE, e cada um criava uma
 * situação permanente enquanto não tinha tela: sem o dia, "não entregue" nunca virava "atrasado",
 * em mês nenhum; sem os critérios, não havia como registrar a versão que destrava um indicador. Os
 * dois endpoints existiam e só eram alcançáveis por fora do sistema. Eles ficam aqui porque é
 * para cá que o roteiro de teste manda quem procura os dois.
 *
 * @returns a tela de listas de apoio
 */
export function PaginaReferencias() {
  return (
    <div className="space-y-4">
      <header>
        <h1 className="titulo-da-pagina">{TEXTOS.referencias.titulo}</h1>
        <p className="mt-1 max-w-prose text-sm text-slate-600">{TEXTOS.referencias.ajuda}</p>
      </header>

      <ListaDeApoio
        qual="sistemas"
        titulo="Sistemas"
        ajuda="Os sistemas que podem sofrer mudança. Aparecem na primeira pergunta do assistente de nova solicitação."
      />

      <ListaDeApoio
        qual="finalidades"
        titulo="Tipos de manutenção"
        ajuda="Os tipos previstos no contrato. É o que separa manutenção corretiva do resto na hora de apurar os indicadores."
      />

      <CalendarioDoContrato />

      <PrazosDosRelatorios />

      <CriteriosDoTr />
    </div>
  )
}
